import { RouteStagedEditDiscardedDtoModelType } from '../../models';
import getAppRoot from '../../utils/getAppRoot';
import getAppEnv from '../../utils/getAppEnv';
import RouteOverviewQuery from '../../queries/routes/RouteOverviewQuery';
import { stagedEditDiscardedNotification } from '../../../../notifications/routes/stagedEditDiscarded';

/**
 * A location change the planner staged on a published route has been reverted, because the driver's own work
 * proved the point had already gone by: they had begun, for a start location, or finished, for an end one. The
 * planner has to be told either way, since the edit was accepted at the time and otherwise they believe the
 * driver is heading somewhere they are not.
 */
export default ({ route, store }: RouteStagedEditDiscardedDtoModelType) => () => {
  const rootStore = getAppRoot(store);
  const projectId = rootStore.ui.selectedWorkspace?.id;

  if (route?.uuid != null) {
    getAppEnv(store).notification(stagedEditDiscardedNotification(route.uuid, route.name));
  }

  if (projectId != null && route?.id != null && rootStore.ui.selectedRoute?.id === route.id) {
    store.queryRouteById({ projectId, routeId: route.id }, RouteOverviewQuery);
  }
};
